import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/starts-with";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import i18n from "@Shared/@i18n/";
import Handlebars from "handlebars";
import { camelCase, kebabCase, startCase, capitalize as _capitalize, toLower as _toLower, upperCase } from "lodash";
import numeral from "numeral";
import { EMAIL_PREFERENCES } from "../constants";
export const splitMessage = (message, metadata, option) => {
  const {
    fileName,
    docTypes,
    documentRequests
  } = metadata;
  message = message.split("\n");
  if (!message) return "";
  if (option === "secondary" && documentRequests && documentRequests.length) return _mapInstanceProperty(documentRequests).call(documentRequests, ({
    documentType
  }) => documentType).join(", ");
  if (option === "secondary" && docTypes && docTypes.length) return docTypes.join(", ");
  if (option === "secondary" && fileName) return fileName;
  if (option === "secondary") return message[1] || "";
  return message[0];
};
export const basicPluralize = (word, count) => {
  return `( ${count} ${count === 1 ? word : `${word}s`})`;
};
export const truncateText = (text, limit) => {
  const textToUse = text || "";
  if (textToUse.length > limit) return `${textToUse.substr(0, limit)}...`;
  return textToUse;
};
export const pluralizeWord = (word, count, inclusive = false) => {
  return pluralize(word, count, inclusive);
};
export const booleanYesNo = value => value ? "Yes" : "No";
export const truncateFileName = (fileName, limit) => {
  const split = fileName.split(".");
  return `${truncateText(split[0], limit)}.${split[1]}`;
};
export const removeHyphens = word => {
  word = word.replace("-", " ");
  const words = word.split(" ");
  const titleizedWords = _mapInstanceProperty(words).call(words, w => {
    if (!w) return;
    if (w.length === 2) return w.toUpperCase();
    return w[0].toUpperCase() + w.substr(1);
  });
  return titleizedWords.join(" ");
};
export const fullName = person => `${person.givenName || ""} ${person.familyName || ""}`;
export const fullNameLowerCase = person => `${toLower(person.givenName) || ""} ${toLower(person.familyName) || ""}`;
export const toUpperAll = name => startCase(name);
export const uppercase = name => upperCase(name);
export const toSentence = value => startCase(toLower(value));
export const toHyphens = name => kebabCase(name);
export const toLower = name => _toLower(name);
export const getCheckText = (object, clientApplication) => {
  const {
    label,
    link
  } = object;
  const {
    username,
    application: {
      applicationId
    }
  } = clientApplication;
  const regExp = /(\w*.*)@(\w+.+)@(.*)/;
  const results = regExp.exec(label);
  if (!results) return label;
  const highlighted = results[2];
  const regular = _filterInstanceProperty(results).call(results, result => result !== highlighted && result !== results[0]).join("");
  if (_startsWithInstanceProperty(label).call(label, "@")) return new Handlebars.SafeString(`<span class="list-highlight property-link" data-client="${username}" data-app="${applicationId}" href="${link}">
        ${highlighted}
      </span> ${regular}`);
  return new Handlebars.SafeString(` ${regular} <span class="list-highlight property-link" data-client="${username}" data-app="${applicationId}" href="${link}">
        ${highlighted}
      </span>`);
};
export const textStatus = dbStatus => {
  const status = {
    new: i18n.t("application.textStatus.new"),
    pending: i18n.t("application.textStatus.pending"),
    submitted: i18n.t("application.textStatus.submitted"),
    "in-review": i18n.t("application.status.inReview"),
    completed: i18n.t("application.textStatus.completed"),
    cancelled: i18n.t("application.textStatus.cancelled")
  };
  return status[dbStatus];
};
export const textStatusShort = dbStatus => {
  const status = {
    new: "Incomplete",
    pending: "Pending",
    submitted: "Submitted",
    "in-review": "Under Review",
    completed: "Completed",
    cancelled: "Cancelled"
  };
  return status[dbStatus];
};
export const trimText = (text = "") => "" + _trimInstanceProperty(text).call(text);
export const userName = name => {
  return name || "This client ";
};
export const formatHyphens = word => {
  return startCase(word);
};
export const formatDateNumber = number => {
  if (number < 10) return `0${number}`;else return number;
};
export const concat = (word1, word2) => {
  return `${word1} ${word2}`;
};
export const concatWithDash = (word1, word2) => {
  const word1Dashes = String(word1).replace(/[^\d\w ]+/, "").replace(/\s+/g, "-").toLowerCase();
  return `${word1Dashes}-${word2}`;
};
export const joinWords = (word1, word2) => {
  return `${word1}[${word2}]`;
};
export const capitalizeFollowup = type => {
  return type === "sms" ? "SMS" : _capitalize(type);
};
export const preferenceText = (preference, portal) => {
  return EMAIL_PREFERENCES[portal][preference];
};
export const singularize = word => pluralize(word, 1);
export const formattedBreaks = text => {
  text = Handlebars.Utils.escapeExpression(text);
  text = text.replace(/(\r\n|\n|\r)/gm, "<br>");
  return new Handlebars.SafeString(text);
};
export const closesText = count => {
  if (count !== 1) return `${count} closes`;
  return `${count} close`;
};
export const closesIncrementIcon = increment => {
  if (increment > 0) return "fa-caret-up";
  if (increment < 0) return "fa-caret-down";
  return "";
};
export const lowerCase = word => {
  return word && word.toLowerCase() || "";
};
export const nameFormat = (givenName = "", familyName = "") => {
  if (!givenName) return;
  const limit = 10;
  const formattedFirstName = givenName.length > limit ? `${givenName.substr(0, 6)}...` : givenName;
  const formattedLastName = familyName.length > limit ? `${familyName.replace(/\W/, "")[0]}.` : familyName;
  return `${formattedFirstName} ${formattedLastName}`;
};
export const formatConsent = (consentStatus, applicationId, clientUsername, reRender) => {
  const map = {
    "not-obtained": "Not Obtained",
    obtained: "Obtained"
  };
  const toDraw = [];
  _Object$entries(map).forEach(([key]) => {
    let item = {
      key,
      name: map[key]
    };
    if (key === consentStatus) {
      item.selected = true;
    }
    toDraw.push(item);
  });
  const selectionItem = item => {
    let output = `
    <a class="dropdown-item clickable btn primary ${item.selected ? "disabled" : ""}" 
    data-consent-key="${item.key}" 
    data-consent-name="${item.name}"
    data-application-id="${applicationId}" 
    data-client-username="${clientUsername}">`;
    if (item.selected) {
      output += '<i class="material-icons" style="top: 3px; font-size: 12px !important;">done</i> ';
    }
    output += `${item.name}</a>`;
    return output;
  };
  let template = "";
  if (reRender) {
    template += `
      <p class="small text-gray mb-0 regular-line-height px-2">
        <span class="bold">Consent Status: </span>
        <span class="consent-status">${map[consentStatus]}</span>
      </p>
      `;
  } else {
    template += `
      <span class="bold">Consent Status: </span>
      <span class="consent-status">${map[consentStatus]}</span>
      `;
  }
  template += `
    <div class="consent-status-dropdown dropdown">
      <a class="grey-text text-darken-4 clickable arrow-consent-dropdown" data-toggle="dropdown">
        <i class="material-icons">arrow_drop_down</i>
      </a>
      <div class="dropdown-menu">
  `;
  toDraw.forEach(option => {
    template += selectionItem(option);
  });
  template += "</div></div>";
  return template;
};
export const upperCaseFirst = string => string[0].toUpperCase() + _sliceInstanceProperty(string).call(string, 1);
export const ordinalIndex = index => numeral(index).format("0o");
export const capitalize = word => _capitalize(word);
export const kebabToSentence = word => startCase(camelCase(word));
export const registerHandlebarHelpers = _Handlebars => {
  _Handlebars.registerHelper("splitMessage", splitMessage);
  _Handlebars.registerHelper("fullName", fullName);
  _Handlebars.registerHelper("fullNameLowerCase", fullNameLowerCase);
  _Handlebars.registerHelper("toSentence", toSentence);
  _Handlebars.registerHelper("toHyphens", toHyphens);
  _Handlebars.registerHelper("toLower", toLower);
  _Handlebars.registerHelper("getCheckText", getCheckText);
  _Handlebars.registerHelper("textStatus", textStatus);
  _Handlebars.registerHelper("textStatusShort", textStatusShort);
  _Handlebars.registerHelper("trimText", trimText);
  _Handlebars.registerHelper("userName", userName);
  _Handlebars.registerHelper("removeHyphens", removeHyphens);
  _Handlebars.registerHelper("formatHyphens", formatHyphens);
  _Handlebars.registerHelper("formatDateNumber", formatDateNumber);
  _Handlebars.registerHelper("concat", concat);
  _Handlebars.registerHelper("concatWithDash", concatWithDash);
  _Handlebars.registerHelper("joinWords", joinWords);
  _Handlebars.registerHelper("capitalizeFollowup", capitalizeFollowup);
  _Handlebars.registerHelper("preferenceText", preferenceText);
  _Handlebars.registerHelper("basicPluralize", basicPluralize);
  _Handlebars.registerHelper("singularize", singularize);
  _Handlebars.registerHelper("formattedBreaks", formattedBreaks);
  _Handlebars.registerHelper("closesText", closesText);
  _Handlebars.registerHelper("closesIncrementIcon", closesIncrementIcon);
  _Handlebars.registerHelper("lowerCase", lowerCase);
  _Handlebars.registerHelper("nameFormat", nameFormat);
  _Handlebars.registerHelper("formatConsent", formatConsent);
  _Handlebars.registerHelper("upperCaseFirst", upperCaseFirst);
  _Handlebars.registerHelper("ordinalIndex", ordinalIndex);
  _Handlebars.registerHelper("capitalize", capitalize);
  _Handlebars.registerHelper("kebabToSentence", kebabToSentence);
  _Handlebars.registerHelper("toUpperAll", toUpperAll);
};